import { IResponseState } from "../../../../components/Modals/ResponseModal/module/constants";
import { IApprovalItem } from "../../../../models/Approval";

export interface IApprovalsRequestListProps {
  approvalMainCallState: IResponseState;
  userInfo: any;
  formValuesApproval: any;
  approvalLoader: boolean;
  tabSelected: string;
  approvalOriginalList: any[];
  rawPaginationTableData: any;
  csvDisabled: boolean;
  csvData: any[];
  getCSVApprovals: (payload: any) => void;
  getPaginatedApprovals: (payload: any) => void;
  fetchApproval: () => {};
  fetchApprove: (request: any) => {};
  fetchReject: (request: any) => {};
  selectApproval: (row: IApprovalItem) => {};
  changeTab: (tab: string) => {};
  changeLocation: (url: string) => {};
  resetApprovalDetail: () => {};
  setFloatSpinner: (active: boolean) => void;
}

export const APPROVAL_TAB = "APPROVAL_TAB";
export const TASK_TAB = "TASK_TAB";

export const REQUEST_ACTION_LIST = [
  {
    label: "AGGREGATED",
    value: 3,
  },
  {
    label: "PERMISSION_ADD",
    value: 1,
  },
  {
    label: "PERMISSION_REMOVE",
    value: 2,
  },
  {
    label: "ACCOUNT_DISABLE",
    value: 6,
  },
  {
    label: "ACCOUNT_ENABLE",
    value: 7,
  },
  {
    label: "ACCOUNT_CREATE",
    value: 8,
  },
  {
    label: "ACCOUNT_REMOVE",
    value: 9,
  },
  {
    label: "ACCOUNT_MODIFY",
    value: 10,
  },
  {
    label: "ACCOUNT_PWDCHANGE",
    value: 11,
  },
];
